
import { Options, Vue } from 'vue-class-component';
import Render           from '@/components/render.vue';

@Options({
  components: {
    Render: Render
  },
  watch:{
    '$route' (to, from){
      this.$refs.configurator.scroll({
        top: 0
      })
    }
  }
})
export default class Configurator extends Vue {

  // store: Store<StateInterface> = useDefaultStore();

  get stateJSON() {
    // return JSON.stringify(this.store?.state, null, 2);
    return JSON.stringify(this.$store.state, null, 2);
  }

}
